<template>
  <v-btn
    class="nx-logo mx-0 px-0"
    flat
    :to="{ 'name': 'default' }"
    active-class="none"
  >
    <nx-bcube-logo
      :height="height"
      :width="width"
      :icon="icon"
    />
    <ds-heading
      v-if="environmentDecorator"
      size="300"
      class="white--text"
    >
      {{ environmentDecorator }}
    </ds-heading>
  </v-btn>
</template>

<script>
import NxBcubeLogo from '@/components/icons/BcubeLogo.vue';

export default {
  name: 'NxLayoutDefaultLogo',
  components: { NxBcubeLogo },
  computed: {
    environmentDecorator() {
      return this.$store.getters.bootstrap.environmentDecorator;
    },
    icon() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    width() {
      return this.icon ? undefined : '100px';
    },
    height() {
      return this.icon ? undefined : '24px';
    },
  },
};
</script>

<style lang="stylus" scoped>
@import "../../assets/stylus/variables.styl"

.nx-logo {
  @media $xs-only {
    min-width 0
    .ds-heading {
      margin-left: 5px
    }
  }
  @media $sm-and-up {
    .ds-heading {
      margin-top: 1px
      margin-left: -6px; // Half logo margin
      margin-right: 11px // Logo margin
    }
  }
}
</style>
